import { testimonials } from '@/mocks/manga';

export default function Testimonials() {
  return (
    <section id="reviews" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <span className="text-sm font-medium text-accent-700">FROM THE COMMUNITY</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">漫友真实评价</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里的每一句评价都来自真实的漫画爱好者。吃了安利，记得也来留下你的感受。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex text-accent-500">
                <i className="ri-star-fill" aria-hidden="true"></i>
                <i className="ri-star-fill" aria-hidden="true"></i>
                <i className="ri-star-fill" aria-hidden="true"></i>
                <i className="ri-star-fill" aria-hidden="true"></i>
                <i className="ri-star-fill" aria-hidden="true"></i>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name}的头像`}
                  title={`${t.name} · ${t.tag}`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.tag}</span>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}